
    var riot = require('riot')
    //src: starling/src/tags/menu/items/menu-item-add-part.html
riot.tag2('menu-item-add-part',
  '<svg class="floating-menu_icon"> <use xlink:href="#add-part-icon"></use> </svg> <span class="floating-menu_label">Add part to card</span>',
  '',
  'class="floating-menu_item" onclick="{addPart}"', function(opts) {
'use strict';

var _util = require('lib/util.js');

var _eventTracking = require('lib/event-tracking');

var _eventTracking2 = _interopRequireDefault(_eventTracking);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var parent = this.parent;
var nodeTag = parent.nodeTag,
    canvas = parent.opts.canvas;

this.addPart = function () {
  var x = parent.x,
      y = parent.y;

  canvas.hidePopups();

  if (nodeTag.instance.getLayoutName() === 'layout-freehand') {
    nodeTag.addPart(x, y);
  } else {
    nodeTag.addPart();
  }

  _eventTracking2.default.track({
    category: (0, _util.getTrackingLabel)(parent),
    action: 'Add-Part',
    label: 'Selection'
  });
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('menu-item-add-part')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/menu/items/menu-item-add-part.html
// module id = 711
// module chunks = 0